import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class RmsHoldingUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.getRmsHoldingDetails(req);
    }
}
export default RmsHoldingUseCase;
